import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';
import { QueryStringBuilder } from '@bayclubs/ui-core';

@Injectable()
export class SellCampApiService {

    constructor(private http: ApiHttpClient) { }

    public get(campId: camps.Guid, clubId: camps.Guid): Observable<api.OperationResultValue<camps.SellCampDetailsModel>> {
        return this.http.get<api.OperationResultValue<camps.SellCampDetailsModel>>(`sell-camp/${campId}/${clubId}`, true);
    }

    public getSummary(query: camps.GetSellCampSummaryRequest): Observable<api.OperationResultValue<camps.PurchaseSummaryModel>> {
        return this.http.get<api.OperationResultValue<camps.PurchaseSummaryModel>>(`sell-camp/summary?` + QueryStringBuilder.buildParametersFromSearch(query).toString(), true);
    }

    public createPurchase(request: camps.CreateCampPurchaseRequest): Observable<api.OperationResultValue<camps.CreateCampPurchaseResponse>> {
        return this.http.post<api.OperationResultValue<camps.CreateCampPurchaseResponse>>(`sell-camp`, request, true);
    }

    public finalize(request: camps.FinalizeCampPurchaseRequest): Observable<api.OperationResultValue<camps.FinalizeCampPurchaseResponse>> {
        return this.http.post<api.OperationResultValue<camps.FinalizeCampPurchaseResponse>>(`sell-camp/finalize`, request, true);
    }

    public getPurchaseStatus(purchaseId: camps.Guid): Observable<api.OperationResultValue<camps.CampPurchaseStatusResponse>> {
        return this.http.get<api.OperationResultValue<camps.CampPurchaseStatusResponse>>(`sell-camp/purchase-status/${purchaseId}`, true);
    }
}
